import type { BadgeVariants } from "./variants";
import type { ThemeColor } from "@/colors/index";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";
import { badgeVariants } from "./variants";

export default defineComponent({
  name: "Badge",
  props: {
    variant: p.string<BadgeVariants["variant"]>("subtle"),
    size: p.string<BadgeVariants["size"]>("sm"),
    radius: p.string<BadgeVariants["radius"]>("md"),
    shadow: p.boolean(),
    label: p.string(),
    color: p.string<ThemeColor>(),
    glow: p.boolean(),
    depth: p.boolean(),
    bordered: p.boolean(),
    dotted: p.boolean(),
  },
  setup(props, { attrs, slots }) {
    return () => (
      <div
        class={cn(
          badgeVariants({
            ...props,
            highContrast: ["yellow", "amber", "lime", "sky"].includes(props.color ?? ""),
          }),
          attrs.class ?? ""
        )}
        data-accent={props.color}
      >
        {props.dotted && (
          <div class="mr-1 block h-1.5 w-1.5 rounded-full bg-accent-10" data-accent={props.color} />
        )}
        {props.label ?? slots.default?.()}
      </div>
    );
  },
});
